import { useTranslation } from 'react-i18next';
import React, {useState, useEffect, Fragment} from 'react';
import ResponsiveDialog from '../shared/components/ResponsiveDialog';
import {List, Grid, DialogContent, ListItem, ListItemIcon, ListItemText, Checkbox, FormControlLabel, Button, FormControl, FormHelperText, Box, CircularProgress, Typography} from '@mui/material';
import apiRequest from '../../functions/api';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
import {useSessionStorage} from '../../utils/hooks';
import RemoveIcon from '@mui/icons-material/Remove';
import { useMessage } from '../../context/message-context';
import { useAuth } from '../../context/auth-context';
import { FullPageSpinner } from '../lib';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
import openFile from "../shared/functions/download";

const AGBComponent = () => {
  const [showModal, setShowModal] = useState(true);
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const {showErrorMessage} = useMessage();
  const {user} = useAuth();
  const { t } = useTranslation();
  useEffect(() => {
    //setIsLoading(true);
    downloadAndOpenFile('AGB');
  }, []);
  
  const acceptCb = (response) => {
    setIsSending(false);
    if (response.status === 200) {
      window.location.reload();
    } else {
      showErrorMessage(t("Es ist ein Fehler aufgetreten"));
    }
  }
  const acceptAGB = () => {
    if (isSending) return
    if (!checked) {
      setError(true);
      return
    }
    setIsSending(true);
    const payload = {
      accept: user.currentagb,
      file: "agb"
    }
    const headers = {
      Authorization: 'Bearer '+accessToken
    }
    apiRequest('POST', 'dataprotection', payload, headers, acceptCb, errorCb);
  }
  const updateChecked = (isChecked) => {
    setChecked(isChecked);
    if (isChecked) {
      setError(false);
    }
  }

  const errorCb = () => {
    setIsSending(false);
    showErrorMessage(t("AGB konnte nicht akzeptiert werden. Bitte versuchen Sie es erneut."));
  }

  const downloadFile = (file) => {
    console.log('file with key: ', file);
    const payload={
        "file": file,
    }
    const headers={
        "Authorization": "Bearer "+accessToken,
        "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL+'resources', payload, {headers: headers, responseType: 'blob'})
      .then((response) => {
        var fileName = file+'.pdf';
        var contentFile = response.data;
        openFile(fileName, contentFile, 'application/pdf');
        loadingFinished();
      })
      .catch(function (error) {
        console.log(error);
        loadingFinished();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  const loadingFinished = () => {
    setShowModal(false);
  }
    
  const downloadAndOpenFile = (key) => {
    setShowModal(true);
    downloadFile(key);
  }

  return(
    <Fragment>
      <Box p={2}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8}>
            <Button fullWidth color="primary" variant="contained" onClick={() => downloadAndOpenFile('AGB')}>{t("Datenschutzerklärung erneut öffnen")}</Button>
            <Box pt={1} pb={1}>
              <FormControl
                error={error}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked} 
                      onChange={(e) => updateChecked(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={t("Ich habe die Datenschutzerklärung gelesen und bin damit einverstanden")}
                />
                <FormHelperText>{error === true && 'Sie müssen die Datenschutzerklärung akzeptieren um die App zu benutzen'}</FormHelperText>
              </FormControl>
            </Box>
            <Button fullWidth color="primary" onClick={() =>acceptAGB()} endIcon={isSending?<CircularProgress />:null}>{t("Weiter")}</Button>
          </Grid>
        </Grid>
      </Box>
      {showModal && <FullPageSpinner/>}
    </Fragment>
  )
}
export default AGBComponent;
